import * as React from "react";
import type { SVGProps } from "react";
const SvgCulinary = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#culinary_svg__a)">
      <path d="M18.06 22h-12a1 1 0 0 1-1-1v-6.41a5 5 0 0 1-2.33-2 5 5 0 0 1-.58-3.79A5 5 0 0 1 7.48 5a5 5 0 0 1 4.58-3 5 5 0 0 1 4.59 3 5 5 0 0 1 2.85.66 5 5 0 0 1 2.34 3 5 5 0 0 1-2.78 5.87V21a1 1 0 0 1-1 1m-11-2h10v-6.13a1 1 0 0 1 .74-1 3 3 0 0 0 1.591-4.73 3 3 0 0 0-.881-.77 3 3 0 0 0-2.28-.29 1 1 0 0 1-.78-.11 1.05 1.05 0 0 1-.46-.65A3 3 0 0 0 12.06 4a3 3 0 0 0-2.93 2.36 1 1 0 0 1-.47.65 1 1 0 0 1-.8.1h-.15a3 3 0 0 0-1.41 5.83 1 1 0 0 1 .76 1z" />
      <path d="M6.22 18a1 1 0 0 1 0-2h11.84a1 1 0 0 1 0 2z" />
    </g>
    <defs>
      <clipPath id="culinary_svg__a">
        <path fill="#fff" d="M2 2h20.01v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCulinary;
